import {Antrag, AntragMeta} from '@wba/models/antrag';
import {Observable} from 'rxjs';


export abstract class AntragService {
  abstract getAntrag(antragId: string): Observable<Antrag>;

  abstract getAntragMetadaten(antragId: string): Observable<AntragMeta>;

  abstract createAntrag(bgNummer: string, formVersion: number): Observable<Antrag>;

  abstract getAntraege(): Observable<Antrag[]>;

  abstract finalizeAntrag(antragId: string): Observable<Antrag>;
}
